import { createContext } from "preact";
import { LocationServiceInterface } from "../interfaces";

export const LocationServiceContext = createContext<LocationServiceInterface | null>(null)